"use client";

import * as React from "react";
import { providers } from "@lib/client";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BugReportIcon from "@mui/icons-material/BugReport";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import PinDropIcon from "@mui/icons-material/PinDrop";
import PercentIcon from "@mui/icons-material/Percent";
import SignpostIcon from "@mui/icons-material/Signpost";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import DomainIcon from "@mui/icons-material/Domain";
import GroupsIcon from "@mui/icons-material/Groups";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import CategoryIcon from "@mui/icons-material/Category";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import NoteIcon from "@mui/icons-material/Note";
import RateReviewIcon from "@mui/icons-material/RateReview";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import RepeatIcon from "@mui/icons-material/Repeat";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PhoneIcon from "@mui/icons-material/Phone";
import StorageIcon from "@mui/icons-material/Storage";
import ViewListIcon from "@mui/icons-material/ViewList";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GavelIcon from "@mui/icons-material/Gavel";
import PaymentIcon from "@mui/icons-material/Payment";
import TableChartIcon from "@mui/icons-material/TableChart";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import BuildIcon from "@mui/icons-material/Build";
import EmailIcon from "@mui/icons-material/Email";

/**
 * ナビゲーションアイテムを生成する関数
 * @param {Object} props - プロパティ
 * @param {Object} props.contextValue - WebAppContextの値
 * @param {Function} props.handleNavigation - ナビゲーション処理を行う関数
 * @returns {Array} ナビゲーションアイテムの配列
 */
export default function Navigation({ contextValue, handleNavigation }) {
  return [
    {
      segment: "dashboard",
      title: "ダッシュボード",
      path: "/dashboard",
      icon: <DashboardIcon />,
      onClick: () => handleNavigation("/dashboard"),
    },
    /*
    {
      segment: "account",
      title: "アカウント設定",
      icon: <PersonIcon />,
      path: "/account",
      onClick: () => handleNavigation("/account"),
    },
    */
    /*
     * 2026-11-02 政美瑠菜
     * 本番は利率変更バッチだけを出す。検証と開発は開発者用メニューをすべて出す。
     * 2026-11-04 政美瑠菜
     * 本番にも部品ランキングCSVを出す。
     * 検証は NODE_ENV=production のため IS_STAGING=true で判定する。
     * 2026-11-04 政美瑠菜
     * 環境での出し分けをやめ、セッションの developer_mode があるときだけ開発者用メニューを出す。
     */
    ...(contextValue?.state?.user?.developer_mode === true
      ? [
          {
            segment: "developer",
            title: "開発者用",
            icon: <BugReportIcon />,
            children: [
              {
                segment: "batch_processing",
                title: "バッチ処理",
                icon: <RepeatIcon />,
                onClick: () => handleNavigation("../batch_processing"),
              },
              {
                segment: "operator_tools",
                title: "運用者用",
                icon: <BuildIcon />,
                onClick: () => handleNavigation("../operator_tools"),
              },
              {
                segment: "unit_test",
                title: "ユニットテスト",
                icon: <BugReportIcon />,
                children: [
                  {
                    segment: "api",
                    title: "APIテスト",
                    icon: <BugReportIcon />,
                    onClick: () => handleNavigation("../unit_test/api"),
                  },
                  {
                    segment: "batch",
                    title: "コグニファイルテスト",
                    icon: <BugReportIcon />,
                    onClick: () => handleNavigation("../unit_test/batch"),
                  },
                  {
                    segment: "account-csv-import",
                    title: "アカウントCSVインポート",
                    icon: <BugReportIcon />,
                    onClick: () => handleNavigation("../unit_test/account-csv-import"),
                  },
                  {
                    segment: "mail",
                    title: "Nodemailerメール送信",
                    icon: <EmailIcon />,
                    onClick: () => handleNavigation("../unit_test/mail"),
                  },
                  /*
                   * 2026-09-30 tdaig
                   * 利率変更バッチをユニットテストメニューに出す
                   */
                  {
                    segment: "invoice",
                    title: "利率変更バッチ",
                    icon: <PercentIcon />,
                    onClick: () => handleNavigation("../unit_test/invoice"),
                  },
                  /*
                   * 2026-11-04 政美瑠菜
                   * 部品ランキングCSVをユニットテストメニューに出す
                   */
                  {
                    segment: "parts-ranking",
                    title: "部品ランキングCSV",
                    icon: <BarChartIcon />,
                    onClick: () => handleNavigation("../unit_test/parts-ranking"),
                  },
                ],
              },
            ],
          },
        ]
      : []),
    // 区切り線
    {
      kind: "divider",
    },
    /*
    {
      segment: "master",
      title: "運用本部",
      icon: <BusinessCenterIcon />,
      children: [
        {
          segment: "notices",
          title: "お知らせ管理",
          icon: <DescriptionIcon />,
          onClick: () => handleNavigation("../notices"),
        },
        {
          segment: "holidays",
          title: "休日設定",
          icon: <CalendarMonthIcon />,
          onClick: () => handleNavigation("../holidays"),
        },
        {
          segment: "master_settings",
          title: "マスタ管理",
          icon: <SettingsIcon />,
          children: [
            {
              segment: "postal_code",
              title: "郵便番号管理",
              icon: <PinDropIcon />,
              onClick: () => handleNavigation("../postal_code"),
            },
            {
              segment: "tax_rate",
              title: "税率変更",
              icon: <PercentIcon />,
              onClick: () => handleNavigation("../tax_rate"),
            },
            {
              segment: "number_name",
              title: "ナンバー地名管理",
              icon: <SignpostIcon />,
              onClick: () => handleNavigation("../number_name"),
            },
          ],
        },
      ],
    },
    */
    {
      segment: "member_company_management",
      title: "会員企業管理",
      icon: <BusinessCenterIcon />,
      children: [
        {
          segment: "companies",
          title: "企業管理",
          icon: <DomainIcon />,
          onClick: () => handleNavigation("../companies"),
        },
        /*
        {
          segment: "accounts",
          title: "アカウント管理",
          icon: <PersonIcon />,
          onClick: () => handleNavigation("../accounts"),
        },
        {
          segment: "groups",
          title: "グループ管理",
          icon: <GroupsIcon />,
          onClick: () => handleNavigation("../groups"),
        },
        {
          segment: "truck_kingdom_members",
          title: "トラック王国会員",
          icon: <CardMembershipIcon />,
          onClick: () => handleNavigation("../truck_kingdom_members"),
        },
        */
      ],
    },

    {
      segment: "sales_data",
      title: "販売データ",
      icon: <BarChartIcon />,
      children: [
        {
          segment: "parts",
          title: "部品",
          icon: <CategoryIcon />,
          onClick: () => handleNavigation("../parts"),
        },
        /*
         * 2026-09-18 Tanaka
         * 顧客評価一覧メニューを新規追加（画面枠のみ）
         */
        {
          segment: "customer_evaluations",
          title: "顧客評価一覧",
          icon: <RateReviewIcon />,
          onClick: () => handleNavigation("../customer_evaluations"),
        },
        /*
        {
          segment: "vehicles",
          title: "車輛",
          icon: <DirectionsCarIcon />,
          onClick: () => handleNavigation("../vehicles"),
        },
        {
          segment: "buyer_questions",
          title: "購入者質問",
          icon: <QuestionAnswerIcon />,
          onClick: () => handleNavigation("../buyer_questions"),
        },
        {
          segment: "producer_questions",
          title: "生産者質問",
          icon: <QuestionAnswerIcon />,
          onClick: () => handleNavigation("../producer_questions"),
        },
        {
          segment: "mogitori_questions",
          title: "もぎとり質問",
          icon: <QuestionAnswerIcon />,
          onClick: () => handleNavigation("../mogitori_questions"),
        },
        {
          segment: "internal_memos",
          title: "社内メモ一覧",
          icon: <NoteIcon />,
          onClick: () => handleNavigation("../internal_memos"),
        },
        {
          segment: "reviews",
          title: "評価一覧",
          icon: <RateReviewIcon />,
          onClick: () => handleNavigation("../reviews"),
        },
        {
          segment: "return_discounts",
          title: "返品値引一覧",
          icon: <AssignmentReturnIcon />,
          onClick: () => handleNavigation("../return_discounts"),
        },
        {
          segment: "return_processing",
          title: "返品処理(月またぎと月内",
          icon: <RepeatIcon />,
          onClick: () => handleNavigation("../return_processing"),
        },
        */
      ],
    },

    /*
    {
      segment: "agent_registration",
      title: "代理登録",
      icon: <PersonAddIcon />,
      children: [
        {
          segment: "tel_fax_agent",
          title: "TEL/FAX代理登録",
          icon: <PhoneIcon />,
          onClick: () => handleNavigation("../tel_fax_agent"),
        },
      ],
    },

    {
      segment: "producer_data",
      title: "生産者データ",
      icon: <StorageIcon />,
      children: [
        {
          segment: "producer_parts_list",
          title: "生産者部品一覧",
          icon: <ViewListIcon />,
          onClick: () => handleNavigation("../producer_parts_list"),
        },
      ],
    },

    {
      segment: "current_vehicle_management",
      title: "現車管理",
      icon: <DirectionsCarIcon />,
      children: [
        {
          segment: "current_vehicle_list",
          title: "現車一覧",
          icon: <ViewListIcon />,
          onClick: () => handleNavigation("../current_vehicle_list"),
        },
      ],
    },
    */

    {
      segment: "accounting_processing",
      title: "経理処理",
      icon: <AccountBalanceIcon />,
      children: [
        /*
        {
          segment: "vehicle_bid_list",
          title: "車輛落札",
          icon: <GavelIcon />,
          onClick: () => handleNavigation("../vehicle_bid_list"),
        },
        */
        {
          segment: "parts_bid_list",
          title: "部品落札",
          icon: <GavelIcon />,
          onClick: () => handleNavigation("../parts_bid_list"),
        },
        /*
        {
          segment: "payment_input",
          title: "入金入力",
          icon: <PaymentIcon />,
          onClick: () => handleNavigation("../payment_input"),
        },
        {
          segment: "yayoi_accounting_csv",
          title: "弥生会計CSV",
          icon: <TableChartIcon />,
          onClick: () => handleNavigation("../yayoi_accounting_csv"),
        },
        {
          segment: "penalty_billing",
          title: "ペナルティ請求",
          icon: <WarningAmberIcon />,
          onClick: () => handleNavigation("../penalty_billing"),
        },
        */
        {
          segment: "commerce_union_billing",
          title: "商工組合請求",
          icon: <ReceiptLongIcon />,
          onClick: () => handleNavigation("../commerce_union_billing"),
        },
        /*
        {
          segment: "ichinen_billing",
          title: "イチネン請求",
          icon: <RequestQuoteIcon />,
          onClick: () => handleNavigation("../ichinen_billing"),
        },
        */
      ],
    },

    {
      segment: "accounting",
      title: "集計",
      icon: <AccountBalanceIcon />,
      children: [
        /*
         * 2026-09-18 Tanaka
         * 粗利分析メニューを新規追加（画面枠のみ）
         */
        {
          segment: "gross_profit_analysis",
          title: "粗利分析",
          icon: <AssessmentIcon />,
          onClick: () => handleNavigation("../gross_profit_analysis"),
        },
        /*
        {
          segment: "sales_list",
          title: "売買一覧",
          icon: <ViewListIcon />,
          onClick: () => handleNavigation("../sales_list"),
        },
        {
          segment: "sales_by_company",
          title: "個社別売上",
          icon: <BarChartIcon />,
          onClick: () => handleNavigation("../sales_by_company"),
        },
        {
          segment: "daily_monthly_report",
          title: "日報月報",
          icon: <DescriptionIcon />,
          onClick: () => handleNavigation("../daily_monthly_report"),
        },
        {
          segment: "parts_info_download",
          title: "部品情報DL",
          icon: <DownloadIcon />,
          onClick: () => handleNavigation("../parts_info_download"),
        },
        {
          segment: "parts_usage",
          title: "部品利用状況",
          icon: <AssessmentIcon />,
          onClick: () => handleNavigation("../parts_usage"),
        },
        {
          segment: "sales_summary",
          title: "営業用集計",
          icon: <ReceiptLongIcon />,
          onClick: () => handleNavigation("../sales_summary"),
        },
        */
      ],
    },
  ];
}
